import {
  Alert,
  Container,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { Helmet } from 'react-helmet-async';
import { Link, useNavigate } from 'react-router-dom';
import CreateTrainingForm from 'src/sections/training/CreateTrainingForm';
import { useMemo, useState } from 'react';
import { TrainingService } from 'src/api';

const CreateTraining = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(null);
  const nav = useNavigate();

  useMemo(() => {
    if (data) {
      async function addTraining() {
        try {
          setLoading(true);
          const result = await TrainingService.createTraining(data);
          if (result.data?.successMessage) {
            nav('../trainings');
          } else {
            throw new Error('Unknown error occured');
          }
        } catch (error) {
          setError(error.message);
        } finally {
          setLoading(false);
          setData(null);
        }
      }
   
      addTraining();
    }
  }, [data]);
  return (
    <>
      <Helmet>
        <title> Create Training | TGHrC</title>
      </Helmet>
      <Container>
        <Stack direction="row" alignItems="center" mb={5}>
          <Link to="../trainings">
            <IconButton aria-label="delete" size="medium">
              <ArrowBack fontSize="small" />
            </IconButton>
          </Link>
          <Typography variant="h4">Create Training</Typography>
        </Stack>
        {error && (
          <Alert variant="standard" severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}
        <CreateTrainingForm
          loading={loading}
          onCreate={data => {
            setError(null);
            return setData(data);
          }}
        />
      </Container>
    </>
  );
};

export default CreateTraining;